document.addEventListener("sections:loaded", () => {
  const toggle = document.querySelector(".menu-toggle");
  const nav = document.querySelector(".mobile-nav");

  if (!toggle || !nav) {
    return;
  }

  const closeMenu = () => {
    nav.classList.remove("is-open");
    toggle.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
  };

  toggle.addEventListener("click", () => {
    const isOpen = nav.classList.toggle("is-open");
    toggle.classList.toggle("is-open", isOpen);
    toggle.setAttribute("aria-expanded", String(isOpen));
  });

  // Desktop layout (`m` breakpoint) hides the mobile nav toggle entirely via
  // CSS, but the open state persists in JS/DOM if the window is resized
  // past it — close it so it isn't left open when the viewport shrinks back.
  window.matchMedia("(min-width: 1000px)").addEventListener("change", (event) => {
    if (event.matches) {
      closeMenu();
    }
  });
});
